import {
    GET_FABRICCLASS_REQUEST,
    GET_FABRICCLASS_SUCCESS,
    GET_FABRICCLASS_ERROR,
    ADD_FABRICCLASS_REQUEST,
    ADD_FABRICCLASS_ERROR,
    ADD_FABRICCLASS_SUCCESS,
    UPDATE_FABRICCLASS_REQUEST,
    UPDATE_FABRICCLASS_SUCCESS,
    UPDATE_FABRICCLASS_ERROR,
    DELETE_FABRICCLASS_ERROR,
    DELETE_FABRICCLASS_REQUEST,
    DELETE_FABRICCLASS_SUCCESS,
  } from "../actions/types";
  export default function (state = [], action) {
    const { type, payload } = action;
    switch (type) {
      case GET_FABRICCLASS_REQUEST:
        return {
          loading: true,
        };
      case GET_FABRICCLASS_SUCCESS:
        return {
          ...state,
          loading: false,
          payload,
        };
      case GET_FABRICCLASS_ERROR:
        return {
          ...state,
          loading: false,
        };
      case ADD_FABRICCLASS_REQUEST:
        return {
          loading: true,
        };
      case ADD_FABRICCLASS_SUCCESS:
        return {
          ...state,
          loading: false,
          payload: [payload],
        };
      case ADD_FABRICCLASS_ERROR:
        return {
          ...state,
          loading: false,
        };
      case DELETE_FABRICCLASS_REQUEST:
        return {
          loading: true,
        };
      case DELETE_FABRICCLASS_SUCCESS:
        return {
          ...state,
          loading: false,
          payload: [payload],
        };
      case DELETE_FABRICCLASS_ERROR:
        return {
          ...state,
          loading: false,
        };
      case UPDATE_FABRICCLASS_REQUEST:
        return {
          loading: true,
        };
      case UPDATE_FABRICCLASS_SUCCESS:
        return {
          ...state,
          loading: false,
          payload: [payload],
        };
      case UPDATE_FABRICCLASS_ERROR:
        return {
          ...state,
          loading: false,
        };
  
      default:
        return state;
    }
  }
  